import * as React from 'react';

// @ts-expect-error
import {InboundCallIconNew} from 'shells/icon/svg/inbound-call-icon-new';
// @ts-expect-error
import {OutboundCallIconNew} from 'shells/icon/svg/outbound-call-icon-new';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

type Props = {
    type: 'PHONE_CALL_INBOUND' | 'PHONE_CALL_OUTBOUND';
};

export function Direction(props: Props) {
    return (
        <Stack isHorizontal={true} spacing={8} alignItems='center' justifyContent='center'>
            {props.type === 'PHONE_CALL_INBOUND' ? (
                <>
                    <InboundCallIconNew size={24} wrapWithDiv={false} />
                    <Body size='small'>In</Body>
                </>
            ) : (
                <>
                    <OutboundCallIconNew size={24} wrapWithDiv={false} />
                    <Body size='small'>Out</Body>
                </>
            )}
        </Stack>
    );
}
